import { Injectable } from '@angular/core';
import { BaseService } from '../../../../admin/src/app/services/base.service';
import { ApiResponse } from '../../../../admin/src/app/models/api-response';
import { SearchResult } from '../models/search-result';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  isSecondSearch = false;

  endpoint: string;

  isZendeskResultsVisible = false;

  isProductsVisible = false;

  isFaqsVisible = false;

  constructor(private baseService: BaseService) {
    this.endpoint = 'search';
  }

  public getAll(query: string, lang: string): Observable<ApiResponse<SearchResult>> {
    return this.baseService.getAll<SearchResult>(this.endpoint, { params: { q: query, lang: lang } })
    .pipe(map(data => {
      let payload = data.payload;
      payload.faqs = payload.faqs || [];
      payload.media = payload.media || [];
      payload.products = payload.products || [];
      return data;
    }));
  }
}
